setPaymentMethodsProcessing